//@import dependencies
import React, {Component} from 'react'
//@end

//@import components
import {PublicScreenLayout} from 'app_components/screens/landing/public'
//@end

// @ADD Component types
interface IPublicScreenProps {}
interface IPublicScreenState {}

class PublicScreen extends Component<IPublicScreenProps, IPublicScreenState> {
  render() {
    return(
      <PublicScreenLayout />
    )
  }
}

export default PublicScreen
